<template>
  <div id="printable" class="content-wrapper">
    <section class="history group-history">
      <h1>{{ $t("group.groupHistory.header") }}</h1>
      <h2 class="report-subhead">Plan: <strong>{{ group.planName }}</strong></h2>
      <h2 class="report-topic">Group: <strong>{{ group.name }}</strong></h2>
    </section>
    <CreditHistory
      v-if="this.historyData.length > 0"
      v-bind:historyData="this.historyData"
    />
    <h4 v-else class="error">{{ $t("group.groupHistory.errorMsg") }}</h4>
  </div>
</template>

<script>
import CreditHistory from '@/components/CreditHistory.vue'

import { groupService } from '@/services/group.service'

export default {
  name: 'GroupHistory',
  components: {
    CreditHistory
  },
  data: function () {
    return {
      group: {},
      historyData: []
    }
  },
  created: function () {
    this.fetchGroup()
  },
  methods: {
    fetchGroup: function () {
      groupService.getGroup(this.$route.params.groupId).then(group => {
        this.group = group
        this.fetchData()
      })
    },
    fetchData: function () {
      // Groups have two possible meters, fetch the appropriate one.
      if(this.group.meterActive) {
        this.fetchOwnMeterEvents()
      }
      else {
        this.fetchMeterEvents()
      }
    },
    fetchMeterEvents: function () {
      groupService.meterEvents(this.$route.params.groupId).then((data) => {
        this.historyData = data.reverse()
      })
    },
    fetchOwnMeterEvents: function () {
      groupService.ownMeterEvents(this.$route.params.groupId).then((data) => {
        this.historyData = data.reverse()
      })
    }
  }
}
</script>

<style lang="scss">
.history {
  max-width: 1186px;
  h1 {
    margin: 0;
  }
}

h2.report-subhead {
  font-size: 20px;
  line-height: 34px;
  margin: 0;
}

h2.report-topic {
  margin-top: 50px;
}

img.print-logo {
  float: right;
}
</style>
